import { render, staticRenderFns } from "./RevisionesInventariosDetalle.vue?vue&type=template&id=7f9c8728&scoped=true"
import script from "./RevisionesInventariosDetalle.vue?vue&type=script&lang=js"
export * from "./RevisionesInventariosDetalle.vue?vue&type=script&lang=js"
import style0 from "./RevisionesInventariosDetalle.vue?vue&type=style&index=0&id=7f9c8728&prod&lang=scss"
import style1 from "./RevisionesInventariosDetalle.vue?vue&type=style&index=1&id=7f9c8728&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9c8728",
  null
  
)

export default component.exports